export default "__VITE_ASSET__7f6eaa7f__"